import { App } from 'vue'
import Grid from './LpGrid.vue'

Grid.install = (Vue: App) => {
  Vue.component(Grid.name, Grid)
}

export default Grid
